export default __webpack_public_path__ + "static/media/038-lifebuoy.ccffc091.png";